export function normalizeInspectionScope(scope) {
  return String(scope || 'FULL').toUpperCase() === 'PARTIAL' ? 'PARTIAL' : 'FULL';
}

/** Match backend inspectionScopeFilter.isTruthyFlag (1 / true / '1' only). */
export function isTruthyInspectionFlag(value) {
  return value === 1 || value === true || value === '1';
}

export function isInstanceInInspectionScope(inst, scope) {
  if (!inst) return false;
  if (normalizeInspectionScope(scope) !== 'PARTIAL') return true;
  return isTruthyInspectionFlag(inst?.include_in_inspection);
}

/** Filter SS instances to those in the building's inspection scope (operational pages). */
export function filterInstancesForInspectionScope(instances, buildingOrScope) {
  const scope =
    typeof buildingOrScope === 'string'
      ? buildingOrScope
      : buildingOrScope?.inspection_scope;
  const list = Array.isArray(instances) ? instances : [];
  if (normalizeInspectionScope(scope) !== 'PARTIAL') return list;
  return list.filter((inst) => isInstanceInInspectionScope(inst, scope));
}

export function isPartialInspectionScope(building) {
  return normalizeInspectionScope(building?.inspection_scope) === 'PARTIAL';
}
